"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseWheelZoom = void 0;
var MouseWheelZoom_1 = require("ol/interaction/MouseWheelZoom");
var MouseWheelZoom = /** @class */ (function () {
    function MouseWheelZoom(map, _mappingTextPack) {
        var _this = this;
        this.map = map;
        this._mappingTextPack = _mappingTextPack;
        this.init = function () {
            var self = _this;
            //only allow mouse wheel zoom when shift key is held down
            var mwzInteraction = null;
            var interactions = _this.map.olMap.getInteractions();
            interactions.forEach(function (interaction, i) {
                if (interaction instanceof MouseWheelZoom_1.default) {
                    mwzInteraction = interaction;
                }
            });
            if (mwzInteraction !== null) {
                _this.map.olMap.on('wheel', function (evt) {
                    //if map is full screen just allow mouse wheel zoom
                    if (document["fullscreenElement"]) {
                        mwzInteraction.setActive(true);
                        return;
                    }
                    var activated = self.ctrlKeyOnly(evt);
                    if (activated) {
                        evt.originalEvent.preventDefault();
                    }
                    mwzInteraction.setActive(activated);
                    //raise event so calling code can decide whether to notify the user
                    self.handleMouseWheelZoom({
                        zoomActivated: activated
                    });
                });
            }
        };
        this.handleMouseWheelZoom = function (args) {
            var self = _this;
            if (!args.zoomActivated && !self._mwzOverlay) {
                var div = $("#" + self.map.options.mapElementId).parent();
                self._mwzOverlay = $("<div class='ctrlToScrollMap'><div>" + self._mappingTextPack.ctrlScollToZoom + "</div></div>");
                div.append(self._mwzOverlay.hide().fadeIn(500));
                setTimeout(function () {
                    self._mwzOverlay.fadeOut(750, function () {
                        self._mwzOverlay.remove();
                        self._mwzOverlay = null;
                    });
                }, 2500);
            }
        };
        this.ctrlKeyOnly = function (mapBrowserEvent) {
            var originalEvent = mapBrowserEvent.originalEvent;
            return (originalEvent["ctrlKey"] &&
                !(originalEvent["metaKey"] || originalEvent["altKey"]) &&
                !originalEvent["shiftKey"]);
        };
        this.init();
    }
    return MouseWheelZoom;
}());
exports.MouseWheelZoom = MouseWheelZoom;
//# sourceMappingURL=MouseWheelZoom.js.map